import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router'
import { WriteoffReportService } from '../services/writeoff-report.service';
import { DeathReportService } from '../services/death-report.service';
import {MatSort, Sort} from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { WriteoffReport } from '../models/writeoff-report';

@Component({
  selector: 'app-writeoff-report',
  templateUrl: './writeoff-report.component.html',
  styleUrls: ['./writeoff-report.component.scss']
})

export class WriteoffReportComponent implements OnInit {
  displayedColumns: string[] = ['id', 'created', 'numberOfWriteoffs', 'startDate', 'endDate', 'writeOffType', 'status', 'updatedAt', 'viewReport']; 
  selection = new SelectionModel<WriteoffReport>(true, []);
  dataSource!: MatTableDataSource<WriteoffReport>;
  dataSourceWithPageSize = new MatTableDataSource<WriteoffReport>();
  errorMessage: string = '';
  isLoadingWriteoffReport: boolean = true;

  constructor(private readonly route: ActivatedRoute, private readonly writeoffReportService: WriteoffReportService, private readonly deathReportService: DeathReportService) { }

  @ViewChild('paginator') set paginator(paginator: MatPaginator) {
    if (!this.dataSource) { return; }
    this.dataSource.paginator = paginator;
  };
  @ViewChild(MatSort) set sort(sort: MatSort) {
    if (!this.dataSource) { return; }
    this.dataSource.sort = sort;
  };

  async ngOnInit(): Promise<void> {
    await this.loadData();
  }

  async loadData(): Promise<void> {
    try {
      const [regularData, deathData] = await Promise.allSettled([
        this.writeoffReportService.getWriteoffReport(),
        this.deathReportService.getDeathReports()
      ]);

      const regular: any[] = regularData.status === 'fulfilled' ? regularData.value : [];
      const death: any[] = deathData.status === 'fulfilled' ? deathData.value : [];

      regular.forEach((element: any) => {
        element.numberOfWriteoffs = element.writeoffs && Array.isArray(element.writeoffs) ? element.writeoffs.length : 0;
        element._isDeathReport = false;
      });

      death.forEach((element: any) => {
        element.numberOfWriteoffs = element.writeoffs && Array.isArray(element.writeoffs) ? element.writeoffs.length : 0;
        element.status = element.status?.toUpperCase();
        element.writeOffType = element.writeoffType?.toUpperCase();
        element._isDeathReport = true;
      });

      const combined = [...regular, ...death];
      this.dataSource = new MatTableDataSource<any>(combined);
      this.isLoadingWriteoffReport = false;

      if (regularData.status === 'rejected' || deathData.status === 'rejected') {
        console.error('Some report data failed to load.');
      }
    } catch (error) {
      this.isLoadingWriteoffReport = false;
      console.error('Error loading data:', error);
      this.errorMessage = 'An error occurred while loading data. Please try again later.';
    }
  }
}